function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    enableBackground: "new 0 0 16 16"
  },
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("rect", {
  style: {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    fillOpacity: 0
  },
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.2 7.1 4.5-5.2h-1.1L8.7 6.4 5.6 1.9H2.1l4.7 6.8-4.7 5.4h1.1l4.1-4.8 3.3 4.8h3.6l-5-7zM7.8 8.7l-.5-.6-3.8-5.4h1.6l3 4.4.5.7 4 5.7H11L7.8 8.7z",
  style: {
    fill: "#fff"
  }
}));
export { SvgX as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI4LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMCIgaWQ9IkxheWVyXzEiIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxNiAxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTYgMTY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbC1ydWxlOmV2ZW5vZGQ7Y2xpcC1ydWxlOmV2ZW5vZGQ7ZmlsbDojRkZGRkZGO2ZpbGwtb3BhY2l0eTowO30KCS5zdDF7ZmlsbDojRkZGRkZGO30KPC9zdHlsZT4KPGc+Cgk8ZyBpZD0idHdpdHRlciI+CgkJPHJlY3QgaWQ9IlJlY3RhbmdsZS1Db3B5LTMiIGNsYXNzPSJzdDAiIC8+Cgk8L2c+Cgk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNOS4yLDcuMWw0LjUtNS4yaC0xLjFMOC43LDYuNEw1LjYsMS45SDIuMWw0LjcsNi44bC00LjcsNS40aDEuMWw0LjEtNC44bDMuMyw0LjhoMy42TDkuMiw3LjFMOS4yLDcuMXoKCQkgTTcuOCw4LjdMNy4zLDguMUwzLjUsMi43aDEuNmwzLDQuNGwwLjUsMC43bDQsNS43SDExTDcuOCw4LjdMNy44LDguN3oiLz4KPC9nPgo8L3N2Zz4K";